import clsx from "clsx";
import React from "react";

interface LinkProps {
	url: string;
	label: string | number;
	target?: string;
	classes?: string;
	showTitle?: boolean;
}

export function Link({
	url,
	label,
	target,
	classes,
	showTitle = false,
}: LinkProps) {
	return (
		<a
			className={clsx(classes)}
			href={url}
			target={target}
			title={showTitle ? label.toString() : undefined}
		>
			{label}
		</a>
	);
}
